import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, styled } from "@mui/material";
import { useEffect, forwardRef } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import * as React from "react";
import { Supplier } from "../../app/slices/supplierSlice";

export const SelectSupplier = forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const _Supplier = useSelector((state) => state.supplier.suppliersList);
  const loading = useSelector((state) => state.supplier.supplier.loading);

  useEffect(() => {
    dispatch(Supplier.getAllList());
  }, []);

  const GroupHeader = styled("div")(({ theme }) => ({
    position: "sticky",
    top: "-8px",
    padding: "4px 10px",
    borderBottom: "1px solid #e0e0e0",
    color: "white",
    backgroundColor: theme.palette.primary.main,
  }));
  const GroupItems = styled("ul")({
    padding: 0,
  });

  return (
    <Autocomplete
      ref={ref}
      {...props}
      options={_Supplier.data || []}
      isOptionEqualToValue={(option, value) => option.id == value.id}
      getOptionLabel={(option) => {
        return option.name;
      }}
      renderInput={(params) => (
        <TextField
          required={props.required}
          error={props.error}
          helperText={props.helperText}
          {...params}
          label="الموردين"
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
      renderGroup={(params, key) => (
        <li key={params.key}>
          <GroupHeader>{params.group}</GroupHeader>
          <GroupItems>{params.children}</GroupItems>
        </li>
      )}
    />
  );
});
